import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "../src/components/Footer";
import Home from "../src/pages/Home";
import { Helmet } from "react-helmet";
import Impressum from "./pages/Impressum";
import Blog from "./pages/Blog";
import Datenschutzerklaerung from "./pages/Datenschutzerklaerung";

function App() {
    return (
        <Router>
            <Helmet>
                <title>Home | Hundefriseur Scheyern</title>
                <meta name="description" content="Hundefriseur Scheyern, wo jeder Hund besonders ist!" />
                <link rel="canonical" href="https://www.hundefriseur-scheyern.de/" />
            </Helmet>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog" element={<Blog/>}/>
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutzerklaerung />} />
            </Routes>
            <Footer />
        </Router>
    );
}

export default App;
